import axios from 'axios'

const http = axios.create({
    /**
     * Não é possível acessar o servidor linux local diretamente.
     * Para acessar os dados, deve abrir no navegador o link http://magistech.dyndns.org
     */
    baseURL: '/end',
})

// http.interceptors.request.use(
//     config => {
//         const token = localStorage.getItem('access_token')
//         if (token) {
//             config.headers.common.Authorization = token
//         }
//         return config
//     },
//     error => {
//         return Promise.reject(error)
//     },
// )

http.interceptors.response.use(
    response => {
      if (response.status === 200 || response.status === 201) {
        return Promise.resolve(response)
      } else {
        return Promise.reject(response)
      }
    },
  error => {
      if (error.message === 'Network Error') {
        // alert('Erro ao conectar com a internet')
        return Promise.reject(error)
      }
      if (error.response.status) {
        switch (error.response.status) {
          case 400:
            // console.log(error)
            console.log(error.response.data.errors)
            break
        //   case 401:
        //     alert('session expired')
        //     break
        //   case 403:
        //     router.replace({
        //       path: '/login',
        //       query: { redirect: router.currentRoute.fullPath },
        //     })
        //      break
        //   case 404:
        //     alert('page not exist')
        //     break
        //   case 502:
        //    setTimeout(() => {
        //       router.replace({
        //         path: '/login',
        //         query: {
        //           redirect: router.currentRoute.fullPath,
        //         },
        //       })
        //     }, 1000)
        }
        return Promise.reject(error.response)
      }
    },
  )

export default http
